import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineLightbulbIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17.45 12.46a7.0002 7.0002 0 0 0-1-9.83 7.0906 7.0906 0 0 0-5.92-1.4 7.0001 7.0001 0 0 0-4 11.15 4.7603 4.7603 0 0 1 1.08 2.86v.29a2 2 0 0 0-.61 1.4v2a2 2 0 0 0 2 2v1a1 1 0 1 0 2 0v-1h2v1a.9997.9997 0 0 0 1 1 1.0001 1.0001 0 0 0 1-1v-1a2 2 0 0 0 2-2v-2a2.0002 2.0002 0 0 0-.57-1.4v-.43a4.2601 4.2601 0 0 1 1.02-2.64ZM9 18.93v-2h6v2H9Zm6.89-7.72a6.1797 6.1797 0 0 0-1.46 3.72H9.56a6.67 6.67 0 0 0-1.5-3.78 5.0002 5.0002 0 0 1 2.84-8A4.9998 4.9998 0 0 1 17 8.07a4.9197 4.9197 0 0 1-1.11 3.14Z"/>
  </SvgIcon>
}

export default LineLightbulbIcon
